import axios from "axios";
import { get_headers, AML_VERIFICATION_URL, AML_VERIFIED_DATA } from "@/utils/constants/constants.js";
import {extractAMLCheckResults,calculateAMLRiskScore 
} from "@/services/verification/integrated_verification_apis/aml_data_extractor";


/**
 * Parses error responses from Axios and returns a user-friendly message.
 * @param {Object} error - Axios error object
 * @param {string} fallbackMessage - Default message if no specific error is found
 * @returns {string} - Parsed error message
 */
function parse_eml_error(error, fallbackMessage) {
  let error_message = fallbackMessage;

  if (error.response) {
    const data = error.response.data;
    if (data?.message) {
      error_message = data.message;
    } else if (typeof data === 'string') {
      try {
        const parsed = JSON.parse(data);
        error_message = parsed.message || error_message;
      } catch {
        error_message = data || error_message;
      }
    }
  } else if (error.request) {
    error_message = 'No response from verification service';
  } else {
    error_message = error.message;
  }

  return error_message;
}

/**
 * AML Verification API function
 * @param {Object} payload - Contains service_id, form_id, application_id
 * @returns {Promise} - API response
 */
export const amlVerify = async (payload) => {
  const headers = get_headers();
    const response = await axios.post(AML_VERIFICATION_URL, payload, { headers });
    return typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
};
/**
 * Get AML Verification Results — ENHANCED WITH EXTRACTED DATA
 */
export const getAMLVerificationResults = async (params = {}) => {
  try {
    const headers = get_headers();
    const entity_profile_id =
      params.entity_profile_id || sessionStorage.getItem("entity_profile_id");
    const service_id = params.service_id;

    if (!entity_profile_id || !service_id) return;

    const response = await axios.get(AML_VERIFIED_DATA, {
      headers,
      params: { entity_profile_id, service_id },
    });

    const data =
      typeof response.data === "string"
        ? JSON.parse(response.data)
        : response.data;

    /** Normalize Status */
    const status_text = (data.status || "").toLowerCase();
    const normalized_status =
      status_text.includes("success") ||
      status_text.includes("pass") ||
      status_text.includes("verified") ||
      status_text.includes("completed")
        ? "success"
        : "fail";

    /** Extract Data Sections */
    const results = data.results_data || data.data || data.details || {};
    const home_affairs = results.HomeAffairs?.RealTimeIDV || {};
    const supplier_data_array = results.HomeAffairs?.SupplierData || [];

    /** Build formatted structure */
    const formatted_results_data = {
      "Home Affairs": home_affairs,
      "Supplier Data": supplier_data_array,
    };

    // **NEW: Extract UI-friendly data**
    const aml_check_results = extractAMLCheckResults(formatted_results_data);
    const risk_score = calculateAMLRiskScore(aml_check_results);

    /** Final Object */
    const result_object = {
      status: normalized_status,
      message:
        data.message ||
        (normalized_status === "fail"
          ? "System verification failed."
          : ""),
      field_results: data.field_results || {},
      results_data: formatted_results_data,
      
      // **NEW: Add extracted data for easy UI consumption**
      aml_check_results,
      risk_score,
      
      service_name: "AML Verification",
    };

    return {
      status: normalized_status,
      results: [result_object],
      raw_data: data,
      service_name: "AML Verification",
    };
  } catch (error) {
    this.show_error(parse_eml_error(error, 'Failed to fetch verification results'));
  }
};